import triggerOne from '../trigger/_triggerone.js';
import { unlisten } from '../_dom/index.js';
import forEach from '../_helpers/foreach.js';
import findDomListeners from '../on/_finddomlisteners.js';
import { dropOwner, hasOwner } from '../on/_owners.js';
import cancelIfGone from './_cancelifgone.js';
// drops the owner from the entries of an event list that carry one of given DOM listeners;
// removes the entries nobody keeps any more
function dropDomOwner(allEvents, name, domEvents, owner) {
  var events = allEvents[name];
  if (!events) {
    return;
  }
  // _bind:KEY and _unbind:KEY entries of one listener share its domEvent
  var retain = events.filter(function (event) {
    return domEvents.indexOf(event.info.domEvent) === -1 || !dropOwner(event, owner);
  });
  if (retain.length) {
    allEvents[name] = retain;
  } else {
    delete allEvents[name];
  }
}
// removes dom listener from nodes bound to given key
// a delegation passes its owner and removes only the listener it added, the one nobody else keeps
export default function removeDomListener(object, def, key, eventName, selector, callback, context, owner) {
  var _props$key;
  if (owner === void 0) {
    owner = null;
  }
  var allEvents = def.events,
    props = def.props;
  var bindEventName = "_bind:" + key;
  var domEvents = findDomListeners(allEvents[bindEventName], {
    eventName: eventName,
    selector: selector,
    callback: callback,
    context: context
  }, !!owner).filter(function (event) {
    return hasOwner(event, owner);
  }).map(function (event) {
    return event.info.domEvent;
  });
  if (!domEvents.length) {
    return object;
  }
  dropDomOwner(allEvents, bindEventName, domEvents, owner);
  dropDomOwner(allEvents, "_unbind:" + key, domEvents, owner);
  // the listeners still kept by somebody else stay
  var kept = (allEvents[bindEventName] || []).map(function (event) {
    return event.info.domEvent;
  });
  var bindings = (_props$key = props[key]) == null ? void 0 : _props$key.bindings;
  forEach(domEvents, function (domEvent) {
    if (kept.indexOf(domEvent) !== -1) {
      return;
    }
    if (bindings) {
      forEach(bindings, function (_ref) {
        var node = _ref.node;
        return unlisten(node, domEvent.eventName, domEvent.selector, domEvent.domEventHandler);
      });
    }
    if (!owner) {
      cancelIfGone(allEvents, domEvent.callback);
    }
    var removeEventData = {
      name: domEvent.name,
      callback: domEvent.callback,
      context: domEvent.context
    };
    triggerOne(object, "removeevent:" + domEvent.name, removeEventData);
    triggerOne(object, 'removeevent', removeEventData);
  });
  return object;
}